<label for="input-{{ name }}">
    {{ label }}
    @if (required) {
        <span aria-hidden="true"> *</span>
    }
</label>

<input
        [formControlName]="controlName"
        id="input-{{ name }}"
        class="form-control ba-input-counter"
        [ngClass]="getAlertClass()"
        type="text"
        [required]="required"
        [maxlength]="maxLetters"
        [attr.aria-invalid]="hasErrors()"
        [attr.aria-required]="required"
        [attr.aria-describedby]="hasAlerts() ? 'error-label-' + name : null"
        [attr.placeholder]="placeholder"
        (blur)="inputLostFocus()"
        (beforeinput)="onBeforeInput($event)"
        data-initialized="true"
/>

@if (hasErrors()) {
    <pf-validation-message [name]="name"
        [validationMessages]="getRelevantErrorMessage()" />
} @else if (hasWarnings()) {
    <pf-warning-message [name]="name"
                        [message]="'common.input.paste-too-long' | i18next:{maxLetters: maxLetters}" />
} @else {
    <div class="form-text">{{ currentLength }} / {{ maxLetters }}</div>
}

<!--screenreader-only-->
<div class="sr-only" role="alert"><span>
 @if (currentLength >= maxLetters) {
     {{ 'common.input.max-letters-reached' | i18next }}
 } @else if (currentLength >= maxLetters - 5) {
     {{ 'common.input.char-count' | i18next:{currentLength: currentLength, maxLetters: maxLetters} }}
 }
 </span></div>
